import { isNetworkError } from './fetchError'

const wait = (ms: number) =>
  new Promise<void>((resolve) => setTimeout(resolve, ms))

/**
 * Runs `fn`, retrying when it fails with a network-layer error (the request
 * never reached the server). Application/HTTP errors are rethrown immediately
 * without a retry, since retrying them would just repeat the same response.
 */
export async function retryOnNetworkError<T>(
  fn: () => Promise<T>,
  options: { retries?: number; delayMs?: number } = {}
): Promise<T> {
  const { retries = 1, delayMs = 1000 } = options
  let attempt = 0
  for (;;) {
    try {
      return await fn()
    } catch (error) {
      if (attempt >= retries || !isNetworkError(error)) throw error
      attempt += 1
      await wait(delayMs)
    }
  }
}
